//@ts-expect-error no type definition for baselines
import { rollingMedianBaseline as baselineFct } from 'baselines';
/**
 * @param data
 */
export function rollingMedianBaseline(data) {
    data.y = baselineFct(data.y).correctedSpectrum;
    return { data };
}
//# sourceMappingURL=rollingMedianBaseline.js.map